var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectaLogoKomentarze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.94 125.49",
    style: {
      enableBackground: "new 0 0 135.94 125.49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E48B53;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E48B53;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.74,6.21c19.13,10.09,30.68,31.7,27.16,54.51c-3.86,25-24.53,43.19-48.55,44.56h-2.03 c-24.02-1.38-44.69-19.57-48.55-44.56c-3.52-22.81,8.03-44.42,27.16-54.51C25.14,16.06,12.38,38.9,16.11,63.05 c4.03,26.1,25.95,44.95,51.16,45.71v0h0.09c0.03,0,0.07,0,0.1,0v0h1.75v0c0.03,0,0.07,0,0.1,0h0.05v0 c25.23-0.73,47.18-19.59,51.21-45.71C124.29,38.9,111.53,16.06,90.74,6.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.77,125.49c0,0-4.2-2.31-6.07-6.66c-0.33-0.76-0.56-1.53-0.72-2.28c-0.16,0.76-0.39,1.52-0.72,2.28 c-1.87,4.35-6.07,6.66-6.07,6.66s-1.16-4.75,0.71-9.09c1.87-4.35,6.07-6.66,6.07-6.66s0,0.02,0.01,0.05 c0.01-0.03,0.01-0.05,0.01-0.05s4.2,2.31,6.07,6.66C75.93,120.74,74.77,125.49,74.77,125.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.64,114.04c3.64-3.77,8.91-4.47,8.91-4.47s-0.62,5.43-4.26,9.2c-3.64,3.78-8.91,4.47-8.91,4.47 S49,117.82,52.64,114.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.76,116.38c-3.92,3.46-9.23,3.71-9.23,3.71s1.05-5.36,4.97-8.82c3.93-3.46,9.24-3.71,9.24-3.71 S51.68,112.91,47.76,116.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.76,101.55c4.34-2.07,9.13-0.92,9.13-0.92s-2.25,4.5-6.59,6.56c-4.34,2.06-9.13,0.91-9.13,0.91 S24.42,103.62,28.76,101.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,112.29c-3.93,3.05-9,2.97-9,2.97s1.31-5.03,5.24-8.09c3.93-3.05,9-2.97,9-2.97S43.13,109.23,39.2,112.29 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.69,101.25c-4.45,1.39-8.91-0.37-8.91-0.37s2.75-4.02,7.2-5.41c4.45-1.39,8.91,0.37,8.91,0.37 S29.13,99.85,24.69,101.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.71,94.4c-4.5,0.54-8.47-1.95-8.47-1.95s3.31-3.36,7.81-3.9c4.49-0.54,8.47,1.95,8.47,1.95 S23.21,93.87,18.71,94.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.02,87.08c-4.53-0.05-8.16-3.03-8.16-3.03s3.7-2.9,8.22-2.85c4.53,0.05,8.16,3.03,8.16,3.03 S18.55,87.13,14.02,87.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.01,79.14c-4.3-0.56-7.44-3.81-7.44-3.81s3.83-2.35,8.13-1.79c4.3,0.56,7.45,3.81,7.45,3.81 S14.31,79.7,10.01,79.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.16,70.98C2.91,70.11,0,66.63,0,66.63s3.98-2.06,8.24-1.18c4.25,0.87,7.16,4.35,7.16,4.35 S11.41,71.86,7.16,70.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.57,63.08c-4.02-1.28-6.49-4.93-6.49-4.93s4.05-1.58,8.07-0.3c4.03,1.28,6.5,4.93,6.5,4.93 S10.59,64.36,6.57,63.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.6,55.02c-3.64-1.78-5.5-5.59-5.5-5.59s4.05-0.93,7.69,0.85c3.64,1.78,5.5,5.59,5.5,5.59 S10.24,56.8,6.6,55.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.51,47.18c-3.25-2.02-4.65-5.77-4.65-5.77s3.88-0.48,7.14,1.54c3.25,2.02,4.65,5.77,4.65,5.77 S10.76,49.2,7.51,47.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.17,39.97c-2.75-2.3-3.57-5.95-3.57-5.95s3.65,0.07,6.4,2.37c2.75,2.3,3.57,5.95,3.57,5.95 S11.92,42.26,9.17,39.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.38,33.27c-2.12-2.55-2.28-6-2.28-6s3.3,0.68,5.42,3.24c2.13,2.55,2.28,6,2.28,6S13.5,35.82,11.38,33.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.14,27.6c-1.78-2.7-1.57-6.04-1.57-6.04s3.11,1.02,4.89,3.72c1.79,2.7,1.57,6.05,1.57,6.05 S15.92,30.3,14.14,27.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,22.36c-1.24-2.82-0.52-5.91-0.52-5.91s2.74,1.47,3.99,4.29c1.25,2.82,0.52,5.91,0.52,5.91 S19.25,25.18,18,22.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.84,17.29c-0.7-2.72,0.41-5.38,0.41-5.38s2.24,1.75,2.94,4.47c0.7,2.72-0.41,5.38-0.41,5.38 S22.54,20.01,21.84,17.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.92,13.19c-0.38-2.61,0.92-4.98,0.92-4.98s1.92,1.87,2.3,4.48c0.38,2.61-0.92,4.98-0.92,4.98 S26.3,15.8,25.92,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.09,9.72c-0.13-2.39,1.24-4.41,1.24-4.41s1.57,1.85,1.7,4.24c0.13,2.39-1.24,4.41-1.24,4.41 S30.22,12.11,30.09,9.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.26,7.25c0.06-2.21,1.46-3.97,1.46-3.97s1.32,1.83,1.26,4.04c-0.05,2.21-1.46,3.97-1.46,3.97 S34.21,9.47,34.26,7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.16,5.37c0.4-1.94,1.93-3.26,1.93-3.26s0.87,1.84,0.47,3.78c-0.4,1.94-1.93,3.26-1.93,3.26 S37.76,7.32,38.16,5.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.36,2.9C42.95,1.09,44.54,0,44.54,0s0.64,1.85,0.06,3.66c-0.58,1.81-2.17,2.91-2.17,2.91 S41.78,4.72,42.36,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.74,2.07c1.3-1.5,3.28-1.87,3.28-1.87s-0.13,2.06-1.43,3.56c-1.3,1.5-3.28,1.87-3.28,1.87 S46.44,3.57,47.74,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.3,114.04c-3.64-3.77-8.91-4.47-8.91-4.47s0.62,5.43,4.26,9.2c3.63,3.78,8.91,4.47,8.91,4.47 S86.94,117.82,83.3,114.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.18,116.38c3.92,3.46,9.23,3.71,9.23,3.71s-1.05-5.36-4.97-8.82c-3.93-3.46-9.24-3.71-9.24-3.71 S84.26,112.91,88.18,116.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.19,101.55c-4.34-2.07-9.13-0.92-9.13-0.92s2.25,4.5,6.59,6.56c4.34,2.06,9.13,0.91,9.13,0.91 S111.53,103.62,107.19,101.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.74,112.29c3.93,3.05,9,2.97,9,2.97s-1.31-5.03-5.24-8.09c-3.93-3.05-9-2.97-9-2.97 S92.81,109.23,96.74,112.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.26,101.25c4.45,1.39,8.91-0.37,8.91-0.37s-2.75-4.02-7.2-5.41c-4.44-1.39-8.91,0.37-8.91,0.37 S106.81,99.85,111.26,101.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.23,94.4c4.5,0.54,8.47-1.95,8.47-1.95s-3.31-3.36-7.81-3.9c-4.49-0.54-8.47,1.95-8.47,1.95 S112.73,93.87,117.23,94.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.92,87.08c4.53-0.05,8.16-3.03,8.16-3.03s-3.7-2.9-8.22-2.85c-4.53,0.05-8.16,3.03-8.16,3.03 S117.39,87.13,121.92,87.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.93,79.14c4.3-0.56,7.44-3.81,7.44-3.81s-3.83-2.35-8.13-1.79c-4.3,0.56-7.44,3.81-7.44,3.81 S121.63,79.7,125.93,79.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.78,70.98c4.25-0.87,7.16-4.35,7.16-4.35s-3.98-2.06-8.24-1.18c-4.25,0.87-7.16,4.35-7.16,4.35 S124.53,71.86,128.78,70.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.37,63.08c4.02-1.28,6.49-4.93,6.49-4.93s-4.05-1.58-8.07-0.3c-4.02,1.28-6.5,4.93-6.5,4.93 S125.35,64.36,129.37,63.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.34,55.02c3.64-1.78,5.5-5.59,5.5-5.59s-4.05-0.93-7.69,0.85c-3.64,1.78-5.5,5.59-5.5,5.59 S125.7,56.8,129.34,55.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.43,47.18c3.25-2.02,4.65-5.77,4.65-5.77s-3.88-0.48-7.14,1.54c-3.26,2.02-4.65,5.77-4.65,5.77 S125.18,49.2,128.43,47.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.77,39.97c2.75-2.3,3.57-5.95,3.57-5.95s-3.65,0.07-6.4,2.37c-2.75,2.3-3.57,5.95-3.57,5.95 S124.02,42.26,126.77,39.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.56,33.27c2.13-2.55,2.28-6,2.28-6s-3.29,0.68-5.42,3.24c-2.13,2.55-2.28,6-2.28,6 S122.43,35.82,124.56,33.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.81,27.6c1.78-2.7,1.57-6.04,1.57-6.04s-3.11,1.02-4.9,3.72c-1.79,2.7-1.57,6.05-1.57,6.05 S120.02,30.3,121.81,27.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.94,22.36c1.24-2.82,0.52-5.91,0.52-5.91s-2.74,1.47-3.99,4.29c-1.25,2.82-0.52,5.91-0.52,5.91 S116.69,25.18,117.94,22.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,17.29c0.7-2.72-0.41-5.38-0.41-5.38s-2.24,1.75-2.94,4.47c-0.7,2.72,0.41,5.38,0.41,5.38 S113.4,20.01,114.1,17.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.02,13.19c0.38-2.61-0.92-4.98-0.92-4.98s-1.92,1.87-2.3,4.48c-0.38,2.61,0.92,4.98,0.92,4.98 S109.64,15.8,110.02,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.85,9.72c0.12-2.39-1.24-4.41-1.24-4.41s-1.57,1.85-1.7,4.24c-0.13,2.39,1.24,4.41,1.24,4.41 S105.72,12.11,105.85,9.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.68,7.25c-0.06-2.21-1.46-3.97-1.46-3.97s-1.32,1.83-1.27,4.04c0.05,2.21,1.46,3.97,1.46,3.97 S101.73,9.47,101.68,7.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.78,5.37c-0.41-1.94-1.93-3.26-1.93-3.26s-0.87,1.84-0.47,3.78c0.4,1.94,1.93,3.26,1.93,3.26 S98.18,7.32,97.78,5.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.58,2.9C92.99,1.09,91.4,0,91.4,0s-0.64,1.85-0.06,3.66c0.58,1.81,2.17,2.91,2.17,2.91 S94.16,4.72,93.58,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.2,2.07c-1.3-1.5-3.28-1.87-3.28-1.87s0.13,2.06,1.44,3.56c1.3,1.5,3.28,1.87,3.28,1.87 S89.5,3.57,88.2,2.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.11,89.73c2.02,4.68,0.76,9.78,0.76,9.78s-4.53-2.48-6.55-7.16c-2.02-4.68-0.76-9.78-0.76-9.78 S56.09,85.05,58.11,89.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.73,86.09c1.1,4.74-0.95,9.3-0.95,9.3s-3.82-3.14-4.92-7.88c-1.09-4.75,0.95-9.31,0.95-9.31 S48.63,81.34,49.73,86.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,81.57c0.31,4.72-2.36,8.75-2.36,8.75s-3.17-3.63-3.47-8.35c-0.31-4.73,2.36-8.75,2.36-8.75 S42.09,76.85,42.4,81.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.13,75.03c-0.4,4.58-3.55,8.04-3.55,8.04s-2.51-3.97-2.11-8.55c0.4-4.58,3.55-8.04,3.55-8.04 S36.53,70.45,36.13,75.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.4,66.93c-1.27,4.22-4.91,6.82-4.91,6.82s-1.58-4.25-0.31-8.46c1.27-4.22,4.9-6.82,4.9-6.82 S32.67,62.71,31.4,66.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.25,57.84c-1.79,3.7-5.53,5.53-5.53,5.53s-0.83-4.16,0.96-7.86c1.79-3.7,5.53-5.53,5.53-5.53 S30.04,54.15,28.25,57.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.65,49.18C24.48,52.07,20.94,53,20.94,53s-0.03-3.75,2.14-6.64c2.17-2.89,5.7-3.82,5.7-3.82 S28.81,46.29,26.65,49.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.38,40.66c-2.4,2.29-5.76,2.59-5.76,2.59s0.53-3.42,2.93-5.7c2.4-2.29,5.76-2.59,5.76-2.59 S29.78,38.37,27.38,40.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.19,33.88c-2.69,1.65-5.89,1.25-5.89,1.25s1.16-3.09,3.85-4.74c2.69-1.65,5.89-1.25,5.89-1.25 S31.88,32.23,29.19,33.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.09,27.33c-2.51,1.29-5.35,0.71-5.35,0.71s1.24-2.67,3.75-3.96c2.51-1.29,5.35-0.7,5.35-0.7 S34.6,26.04,32.09,27.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.3,21.61c-2.42,0.91-4.95,0.08-4.95,0.08s1.4-2.31,3.82-3.22c2.42-0.91,4.95-0.08,4.95-0.08 S37.72,20.7,35.3,21.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.89,16.75c-2.33,0.57-4.58-0.47-4.58-0.47s1.54-1.98,3.87-2.56c2.33-0.58,4.58,0.47,4.58,0.47 S42.22,16.17,39.89,16.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.86,13.14c-2.21,0.17-4.11-1.13-4.11-1.13s1.69-1.57,3.9-1.74c2.21-0.17,4.11,1.13,4.11,1.13 S47.07,12.97,44.86,13.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.29,9.72c-1.98,0.15-3.68-1.01-3.68-1.01s1.51-1.41,3.5-1.56c1.98-0.15,3.68,1.01,3.68,1.01 S51.28,9.56,49.29,9.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.78,85.57c0,0-4.05,2.23-5.86,6.41c-0.31,0.73-0.54,1.47-0.69,2.2c-0.16-0.73-0.38-1.47-0.7-2.2 c-1.81-4.19-5.86-6.41-5.86-6.41s-1.12,4.57,0.69,8.76c1.81,4.19,5.86,6.41,5.86,6.41s0-0.02,0.01-0.05 c0,0.03,0.01,0.05,0.01,0.05s4.05-2.22,5.86-6.41C75.9,90.14,74.78,85.57,74.78,85.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.33,89.73c-2.02,4.68-0.77,9.78-0.77,9.78s4.53-2.48,6.55-7.16c2.02-4.68,0.76-9.78,0.76-9.78 S80.35,85.05,78.33,89.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.71,86.09c-1.1,4.74,0.95,9.3,0.95,9.3s3.82-3.14,4.92-7.88c1.1-4.75-0.95-9.31-0.95-9.31 S87.81,81.34,86.71,86.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.04,81.57c-0.31,4.72,2.36,8.75,2.36,8.75s3.17-3.63,3.47-8.35c0.3-4.73-2.36-8.75-2.36-8.75 S94.35,76.85,94.04,81.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.31,75.03c0.4,4.58,3.55,8.04,3.55,8.04s2.51-3.97,2.11-8.55c-0.4-4.58-3.55-8.04-3.55-8.04 S99.91,70.45,100.31,75.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.04,66.93c1.27,4.22,4.91,6.82,4.91,6.82s1.58-4.25,0.31-8.46c-1.27-4.22-4.91-6.82-4.91-6.82 S103.77,62.71,105.04,66.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.19,57.84c1.8,3.7,5.53,5.53,5.53,5.53s0.83-4.16-0.96-7.86c-1.79-3.7-5.53-5.53-5.53-5.53 S106.4,54.15,108.19,57.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.79,49.18c2.17,2.88,5.71,3.82,5.71,3.82s0.03-3.75-2.14-6.64c-2.17-2.89-5.71-3.82-5.71-3.82 S107.62,46.29,109.79,49.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.06,40.66c2.4,2.29,5.76,2.59,5.76,2.59s-0.53-3.42-2.93-5.7c-2.4-2.29-5.76-2.59-5.76-2.59 S106.66,38.37,109.06,40.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.25,33.88c2.69,1.65,5.89,1.25,5.89,1.25s-1.16-3.09-3.85-4.74c-2.69-1.65-5.89-1.25-5.89-1.25 S104.56,32.23,107.25,33.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.35,27.33c2.51,1.29,5.35,0.71,5.35,0.71s-1.24-2.67-3.75-3.96c-2.51-1.29-5.35-0.7-5.35-0.7 S101.84,26.04,104.35,27.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.14,21.61c2.42,0.91,4.95,0.08,4.95,0.08s-1.4-2.31-3.82-3.22c-2.42-0.91-4.95-0.08-4.95-0.08 S98.72,20.7,101.14,21.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.55,16.75c2.33,0.57,4.58-0.47,4.58-0.47s-1.53-1.98-3.87-2.56c-2.33-0.58-4.58,0.47-4.58,0.47 S94.22,16.17,96.55,16.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.58,13.14c2.21,0.17,4.11-1.13,4.11-1.13s-1.69-1.57-3.9-1.74c-2.21-0.17-4.11,1.13-4.11,1.13 S89.37,12.97,91.58,13.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.15,9.72c1.98,0.15,3.68-1.01,3.68-1.01s-1.51-1.41-3.5-1.56C85.35,7,83.65,8.16,83.65,8.16 S85.16,9.56,87.15,9.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.74,6.21c18.5,9.76,28.91,30.66,25.51,52.72c-3.73,24.17-23.72,41.75-46.94,43.09h-1.97 c-23.22-1.33-43.21-18.92-46.94-43.09c-3.4-22.05,7.01-42.96,25.51-52.72c-20.1,9.52-31.69,31.61-28.09,54.96 c3.89,25.23,25.09,43.46,49.46,44.19v0h0.09c0.03,0,0.07,0,0.1,0v0h1.69v0c0.03,0,0.07,0,0.1,0h0.05v0 c24.39-0.71,45.61-18.94,49.51-44.19C122.43,37.82,110.84,15.74,90.74,6.21"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectaLogoKomentarze);
export default __webpack_public_path__ + "static/media/Recta_logo_komentarze.3e4d57db9fa66fb435ef178beb72e05a.svg";
export { ForwardRef as ReactComponent };